import i18n from 'i18next';
import { get } from 'lodash';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

const DEFAULT_LANG = 'de';

// https://svgflags.com/

const MAP = {
  de: {
    key: 'de',
    name: 'Deutsch',
    direction: 'left-to-right',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 480'>
        <path fill='#fc0' d='M0 320h640v160H0z' />
        <path fill='#000001' d='M0 0h640v160H0z' />
        <path fill='red' d='M0 160h640v160H0z' />
      </svg>
    ),
  },
  en: {
    key: 'en',
    name: 'English',
    direction: 'left-to-right',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-gb' viewBox='0 0 640 480'>
        <path fill='#012169' d='M0 0h640v480H0z' />
        <path fill='#FFF' d='m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z' />
        <path
          fill='#C8102E'
          d='m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z'
        />
        <path fill='#FFF' d='M241 0v480h160V0zM0 160v160h640V160z' />
        <path fill='#C8102E' d='M0 193v96h640v-96zM273 0v480h96V0z' />
      </svg>
    ),
  },
  fr: {
    key: 'fr',
    name: 'Français',
    direction: 'left-to-right',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-fr' viewBox='0 0 640 480'>
        <path fill='#fff' d='M0 0h640v480H0z' />
        <path fill='#000091' d='M0 0h213.3v480H0z' />
        <path fill='#e1000f' d='M426.7 0H640v480H426.7z' />
      </svg>
    ),
  },
  it: {
    key: 'it',
    name: 'Italiano',
    direction: 'left-to-right',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-it' viewBox='0 0 640 480'>
        <g fillRule='evenodd' strokeWidth='1pt'>
          <path fill='#fff' d='M0 0h640v480H0z' />
          <path fill='#009246' d='M0 0h213.3v480H0z' />
          <path fill='#ce2b37' d='M426.7 0H640v480H426.7z' />
        </g>
      </svg>
    ),
  },
  ar: {
    key: 'ar',
    name: 'العربية',
    direction: 'right-to-left',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-sa' viewBox='0 0 640 480'>
        <defs>
          <clipPath id='sa-a'>
            <path fillOpacity='.7' d='M-85.3 0h682.6v512H-85.3z' />
          </clipPath>
        </defs>
        <g fillRule='evenodd' clipPath='url(#sa-a)' transform='translate(80)scale(.9375)'>
          <path fill='#165d31' d='M-128 0h768v512h-768z' />
          <path
            fill='#fff'
            d='M65.5 145.1c-.8 12-2 33 8.3 35.2 12.3 1.2 5.5-20.8 10-24.8.8-2 2.3-2 2.4.5v18.7c0 6 4 7.8 7 9 3.2-.2 5.4 0 6.6 3l1.6 32.3s7.4 2.2 7.8-18.1c.3-12-2.4-21.9-.8-24.2 0-2.3 3-2.4 5-1.3 3.2 2.2 4.6 5 9.6 4 7.6-2.2 12.2-5.9 12.3-11.7a47 47 0 0 0-3.5-16.6c.4-1-1.4-3.7-1-4.7 1.3 2.2 3.4 2 3.8 0-1.3-4.2-3.3-8.3-6.5-10-2.7-2.4-6.7-2-8 3-.8 5.7 2 12.4 6.1 18 .9 2.1 2.1 5.7 1.6 8.9q-3.4 1.8-6.3-1.2s-6-4.5-6-5.6c1.6-10.2.3-11.4-.6-14.3-.6-3.9-2.5-5.2-4-7.8-1.5-1.6-3.5-1.6-4.5 0-2.7 4.6-1.4 14.5.5 19 1.4 4.1 3.5 6.7 2.5 6.7-.8 2.3-2.5 1.7-3.8-1a67 67 0 0 1-2.1-17.4c-.5-4.6-1.1-14.4-4.2-17-1.8-2.4-4.5-1.2-5.5 1a82 82 0 0 0 .3 13.4c2 7.4 2.7 14 3.7 21.5.3 10.1-5.8 4.4-5.5-.7a45 45 0 0 0-.3-19.4c-1-2.6-2.1-3.2-4.6-2.8-1.9 0-6.8 5.3-8.2 14.3 0 0-1.2 4.6-1.7 8.7-.7 4.6-3.7 8-5.9-.6-1.8-6.3-3-21.6-6-18z'
          />
          <path fill='#fff' d='m99 194.2-32 15.4c.3-7.3 15.1-20.4 25.3-20.5 6.5.1 4.9 2.5 6.6 5.1z' />
          <path
            fill='#fff'
            d='M93.3 204.2c-16.8 43.5 39.5 49.6 45.8 1.8.6-2 3-3.9 3.4-.7-1.3 43.3-43.6 46.2-50.8 32.6a42 42 0 0 1-2.5-14.6c-1-8.5-5.5-5.2-6.2 3.2-.7 4.7-.5 6-.5 10.5 2.2 34.2 56.7 19.5 65.6-8.7 4.7-15.6-.8-27.1 1.7-27.1 5.4 5.8 13 .8 14.7-1.2.7-1 2.5-1.7 3.7-.4 4.2 3 11.6 1.6 13.2-3.7q1.4-8 1.8-16.2c-3.5 1-6 1.7-6.3 3.2l-.7 4.6c-.3 1.5-3.2 1.5-3.4-.4-1.3-6-6.7-6.7-10 2.5-2.1 1.8-6.1 2.2-6.5-.5.5-6.2-2-7-7-4.1l-4.8-36.2c2 0 4 1.5 5.9-.9-2-6.5-6.5-19.7-9-20.7-1.1-1.4-2.1-.5-3.7-.1-2.6.8-5 3-4.2 7.4 3 18.8 5 33.1 8.1 52 .5 2.1-1.3 5-3.7 4.7-4-2.7-5-8.2-12-8-5 0-10.6 5.5-11.3 10.7-.9 4.2-1.2 8.7 0 12.3 3.5 4.2 7.7 3.8 11.4 2.9 3-1.3 5.5-4.3 6.6-3.6.7.9.1 10.9-14.3 18.5-8.7 4-15.7 4.8-19.4-2.3-2.3-4.5.2-21.4-5.6-17.5'
          />
          <path
            fill='#fff'
            d='M165 160c3.3-1.2 19.3-19.6 19.3-19.6l-2.4-2q-1.3-1.1 0-2.2c4-2.4 2.7-7.4.7-9.8a10 10 0 0 0-8.7.1c-2.8 2.7-3.4 7-1.2 9.6 2.1 1 4.2 3.2 2.8 4.4-6.6 7-24.5 19.1-22.4 19.5.4.6 11.5.6 11.8 0zm-97 65c-6 9.6-6.5 23.9-3.2 28.2 1.8 2 4.7 2.9 6.8 2.2 3.8-1.6 5.5-9.3 4.6-12q-1.8-3-3.6-.7c-2.6 5.4-3.7 1.7-4-1.3a70 70 0 0 1 .8-15.2c.7-4.2 0-3-1.4-1.2m257.1-15.3c-5.8-12.6-13.9-25-16.4-29.7a558 558 0 0 0-24.8-36c-6.2-7.4 10.2 3.1-2-11.7l-8.9-7.5c-2-1.4-6.8-4-7.6.2-.4 3.8-.2 5.8.4 8.9.5 2 3.5 5.5 5 7.5a565 565 0 0 1 53.8 86.5c2.6-1.3 2-16.1.5-18.2'
          />
          <path
            fill='#fff'
            d='M299.6 251.5c-1.2 1.3 2.8 6.8 8 6.8 8.6-1 16.2-5.8 23.2-18.6a33 33 0 0 0 5.3-14.2 317 317 0 0 0-5.8-72.4c-.3-2 0-4.4.2-5 .6-.7 2.5 0 3.5-1.7 1.5-1.5-4-14-7-18.7-1-2.2-1.5-3.6-3.3.2a27 27 0 0 0-3 13.6c4.1 28.5 5.4 53.4 8 81.9.3 2.8-.1 6.8-2 8.4a80 80 0 0 1-27.1 19.7m116.5-.1c-6.2 3.6-6.2 7.7-1.2 7.8 8.6-1 18.8-1.7 25.8-12.3a41 41 0 0 0 4.2-16 303 303 0 0 0-4.7-71.4c-.2-2-1.1-6.7-.8-7.3.6-1.4 3.4.1 4.4-1.5 1.4-1.5-7.3-12.7-10.4-17.5-1-2.2-1.4-3.6-3.3.2a22 22 0 0 0-1.8 13.6c4.6 31 8 54.2 8.7 81.6-.4 2.6-.5 4-1.7 7.3-2.7 3.4-5.7 7.8-8.5 9.9-2.8 2-8.8 4-10.7 5.6'
          />
          <path
            fill='#fff'
            d='M420.7 223.7q.1-10.9-.1-19a34 34 0 0 0-3-13.5c-1.8-4.1-.7-7.4-1.6-11.8-.8-4.4-.6-11-1.8-16.1-.4-2-1.4-8.5-1.1-9.2.5-1.4 2.4 0 3.4-1.6 1.4-1.5-5-18-8.2-22.7-1.1-2.1-3.3-1.4-5.8 2-2.5 2.3-1.6 7.4-.6 12.3 6.1 32.3 10.8 61.6 9.8 92.3-.4 2.6 9-7.8 9-12.7m-45.7-40c-3.9-.2-12-7.7-14.4-12a8 8 0 0 1 .4-6.5c1.5-1 3.7-2 5.4-1 0 0 1.7 2.4 1.4 2.7 2 1 3 .5 3.2-.4.1-1.5-.6-2.4-.6-4 .9-4.6 6-5.3 8-2.4 1.4 1.8 2 5.5 2.1 8 0 1.3-2-.2-3.3 0-1.1.4-1.4 1.8-1.5 3-.2 3.3-.6 8.6-.7 12.5zm-71.8 48c1-9.8-.4-27.3-.5-33.1A477 477 0 0 0 299 154c-1.2-8.4 3.4.9 2.8-4-1.5-8.3-6.1-14-11.6-21.5-1.7-2.5-1.7-3-4.4.6-3 6.7-.4 11.4.4 16.7 3.9 17.2 6.2 33 7.3 48.7a393 393 0 0 1 .4 49c3 .1 7.6-4.7 9.3-11.8'
          />
          <path
            fill='#fff'
            d='M434 216c-6.9-11.6-17.2-24-20-28.7a658 658 0 0 0-29.2-37.8c-8.5-9 4-1.5-1.6-8.5-4.7-5.1-6-6.8-10.1-9.9-2-1.3-3.2-3.8-4 .5a83 83 0 0 0-.2 11.2c0 1.7 1.8 5 3.4 7 20.7 25.5 43.4 51.5 61.6 84.2 2.6-1.3 1.7-16 0-18z'
          />
          <path
            fill='#165d31'
            d='M122.6 194.7c-.5.9-1.6 2-1.2 3.1q1 1.4 2.6 1.3c1.1 0 2.7.3 3-.3q1-1.2.6-3.3c-1.2-3-4.4-1.8-5-.8'
          />
          <path
            fill='#fff'
            d='M354.2 362.5c9.2.4 15.2.5 23.3 1.4l9.6-1c10.6-1 11 15.1 11 15.1 0 9.5-3.7 10-8.4 11-2.7.4-4-1.6-5.5-3.6a14 14 0 0 1-7 .4l-11.5-.5c-4-.3-6.2.5-10.3.1-.8 1.3-2 3.1-4.4 2.6-2-.3-4.5-6-3.8-10.5 1.5-3.2 1-2.1 1-3.5-37.6-1-75.5-2.7-112.3-2.2-28.8.1-57.2 1.3-85.7 2.5-15.2-.2-26.8-2.6-34.8-14.3.8 0 38.8 2.1 49.9 1.4 20.5-.2 39.3-1.9 60.2-2.5 41.2.7 82.1.7 123.3 3.6-4-2.7-4-9 2-10.6.5-.4.8 3.1 1.7 3 4.9-.3 2.7 6.3 1.7 7.6M188.6 135.3c-6.2 17.8 3.6 37.4 10.4 35.5 5 2 8-7.4 10-17.6 1.5-2.9 2.5-3.2 3.2-1.7-.2 13.6 1 16.7 4.5 20.8 7.8 6 14.3.8 14.8.3l6-6.1q2.2-2.2 5.1-.3c1.9 1.7 1.6 4.6 5.6 6.6 3.4 1.4 10.5.4 12.2-2.5 2.2-3.9 2.8-5.2 3.8-6.6 1.6-2.1 4.3-1.2 4.3-.5-.3 1.2-1.9 2.3-.8 4.5 2 1.4 2.4.5 3.5.2 4-2 7-10.6 7-10.6.1-3.2-1.7-3-2.9-2.2l-3.1 2.1c-2 .3-5.7 1.6-7.6-1.3-1.9-3.4-1.9-8.3-3.3-11.8 0-.2-2.6-5.5-.2-5.8 1.2.2 3.7.9 4.1-1.2 1.2-2.1-2.6-8-5.3-11-2.3-2.5-5.5-2.8-8.6-.2-2.2 2-1.9 4.2-2.3 6.3a10 10 0 0 0 2 8.7c2.2 4.2 6.1 9.7 4.8 17.5 0 0-2.3 3.6-6.3 3.1-1.7-.3-4.4-1-5.8-11.8-1.1-8 .2-19.4-3.2-24.7-1.3-3.3-2.2-6.4-5.2-.9-.8 2.2-4.3 5.5-1.8 12.2a36 36 0 0 1 2 19c-1.5 2.2-1.8 2.9-3.7 5-2.6 3-5.5 2.2-7.7 1.1-2-1.3-3.6-2-4.6-6.5.2-7 .6-18.5-.7-20.9-1.9-3.8-5-2.4-6.3-1.2a48 48 0 0 0-11.5 23.5c-1.8 5.8-3.7 4.1-5 1.8-3.2-3-3.5-26.7-7.4-22.8'
          />
          <path
            fill='#fff'
            d='M207.4 174.1c2.9-2 1.6-3.4 5.8.8a72 72 0 0 1 9.2 31.3c-.2 2.6 1.6 4.2 2.5 3.6.4-6 15.1-14.4 28.6-15.6 2-.5 1-4.4 1.3-6.4-.8-7.5 4.2-14.3 11.2-14.8 9.6 1.4 12.8 6.5 13 14.2-1.1 15-16.7 17.5-25.4 18.7-1.3.5-1.9 1.1 0 1.8l36.6.2 1.9 1c.2 1-.6.2-2 2.6a30 30 0 0 0-3.7 11.5c-10.9 3.6-22.2 5-33.6 6.5-4 2-6 4.7-5.2 7.7 1.4 3.3 10.2 6.7 10.2 6.8 1.7 1 3.6 3.5-.5 8.6-17.8-.8-31.7-8.4-36.5-19.1-1.4-1.1-3 0-4 1.4-7 9-13.8 17-25.7 21.4-7 1.8-14.3-1.1-17.7-5.7-2.3-2.7-2.2-5.6-3-6.2-3.9 1.7-36.9 15.7-32.7 9.1 8-8.5 22-14.9 34.2-23.3.9-2.9 2.5-12.5 7.3-15.6.3 0-.7 5.6-.6 8 0 2-.2 2.7.2 2.2.9-.5 15.7-12.2 17-15.8 1.4-2 .3-7.2.3-7.4-2.8-7.2-6.7-7.8-8.1-11.4-1.3-4.7-.7-10.1 2-11.7q3.7-3.1 7.9.5c3 2.7 5.6 8 6.4 11.9-.5 1.5-4-1-5-.3a16 16 0 0 1 3.7 7.8c2 8.2 1.4 11.4-.6 16.7-6.6 13.9-15 18-22.4 23.2-.2 0-.3 3.5 2.4 5.4 1 1 4.9 1.5 9.4 0a55 55 0 0 0 22.3-23.3 51 51 0 0 0-2.4-22.2c-2.9-6.7-6.3-16.2-6.3-16.4-.1-4.2.2-5.6 2-7.7m-95.8-38.6c4.2 2 12.2 1.1 11.8-5.7l-.2-3.1c-.8-2-3.2-1.5-3.7.5-.2.7.3 1.8-.3 2.1-.4.4-1.7.2-1.7-1.7q-.1-1-.7-1.6-.2-.2-.9-.2c-.6 0-.6.1-.9.6l-.3 1.6q-.1.9-.8 1c-.6 0-.5 0-1-.2q-.4-.3-.5-1l-.3-1.6q-.3-.4-1-.6c-2.3 0-2.5 2.7-2.3 3.7-.2.2-.3 4.9 2.8 6.2'
          />
          <path
            fill='#fff'
            d='M235.1 187.7c4.2 2 14.3.9 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.6-.2.6.3 1.7-.4 2-.3.4-1.7.2-1.6-1.6q-.1-1-.7-1.7-.3-.2-1-.2c-.5 0-.5.2-.8.7q-.3.7-.3 1.6-.2.8-.9 1c-.5 0-.4 0-.8-.3q-.5-.3-.6-.9l-.3-1.6q-.3-.5-1-.6c-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 5 3 6.2zm72-21.6c4.2 2 12.1 1.1 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.5-.2.7.3 1.8-.4 2.2-.3.3-1.7.1-1.6-1.8q-.1-1-.7-1.6-.3-.2-1-.2t-.8.7l-.3 1.5q-.1 1-.9 1c-.8 0-.4 0-.8-.2q-.5-.3-.6-.9 0-1-.3-1.7-.4-.4-1-.5c-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 4.9 3 6.2zm37.3 54.3c-7.3 8.3-4.1 22-2.4 25 2.4 4.8 4.3 7.9 9 10.3 4.3 3.1 7.7 1.2 9.5-1 4.3-4.5 4.4-16 6.4-18.2 1.4-4.2 5-3.5 6.7-1.6a17 17 0 0 0 6.2 5.3c4 3.5 8.8 4.2 13.6 1 3.2-1.9 5.3-4.2 7.2-8.9 2-5.6 1-31.6.5-47l-4.2-21.5c0-.2-.5-10.2-1-12.5 0-1-.3-1.3.7-1.2 1.1 1 1.2 1 2 1.3 1 .2 2-1.7 1.3-3.3l-10-18.6c-.8-.8-1.9-1.6-3.2.2a7 7 0 0 0-2.4 5.5l1.3 13.3 4 22.6c1.3 16 1.6 29.2 2.9 45.3-.2 6.8-2.3 12.7-4.3 13.6 0 0-3 1.7-5-.2-1.5-.6-7.4-9.9-7.4-9.9-3-2.7-5-2-7.1 0-6 5.8-8.6 16.4-12.7 23.8-1 1.7-4 3-7.2-.1-8.2-11.3-3.4-27.3-4.4-23.2M309 126.7c3.8 1.5 6.4 9.2 5.6 13-.8 4.5-2.8 9.5-4.2 8.9-1.6-.6 1-4.6-.5-8.8-.8-2.8-6-7.8-5.4-9.2-1-3.1 2.2-4.5 4.5-4z'
          />
          <path
            fill='#fff'
            d='M356.6 225c.7-9.2-.6-14.8-.8-20.2s-6.1-46.6-7.3-50.6c-1.5-7.8 5.7-1 4.9-5.6-2.5-5.6-8.6-13.9-10.5-18.8-1.2-2-.7-4-3.3-.5a42 42 0 0 0-2.3 19.2c6.2 32.3 12.5 59.1 11.5 89.8 3 0 6.3-6.7 7.8-13.3m64.4-85.3c3.5 1.7 5.5 11.3 5.1 14-.7 5-2.5 10.4-3.8 9.7-1.5-.6.3-7.4-.4-9.5-.8-3-5.5-8.4-5-10-1-3.4 2-4.8 4.1-4.2m-255.7 67.9c3.3 1.3 5.3 8.3 5 10.3-.8 3.7-2.5 7.7-3.8 7.1-1.3-.4.3-5.4-.3-7-.3-3.7-4.9-5.7-4.8-7.3-.8-3 2-3.5 4-3.1z'
          />
          <path
            fill='#165d31'
            d='M244.9 218.2c4.2.2 6.3 3.6 2.4 5-4 1.3-7.7 2.4-7.8 8 1.5 8-2 5.2-4 4.2-2.4-1.8-9.2-6-10.2-15-.1-2.1 1.6-4 4.3-4 4 1.1 10 1.2 15.3 1.8'
          />
          <path
            fill='#fff'
            d='M77.4 124.4c4.8 1.4 5.1 8.6 4.8 10.7-.7 3.8-2.4 7.9-3.6 7.4-1.4-.5 0-5.7-.7-7.3-.7-2.2-4.8-6.4-4.4-7.6-.9-2.5 2-3.7 3.9-3.2m95.9 33.6c-3.8 2-5.2 8-2.9 11.6 2.2 3 5.6 1.9 6 1.9 3.7.4 5.9-6.9 5.9-6.9s.1-2-4.2 1.9c-1.9.3-2-.4-2.5-1.4a9 9 0 0 1 .5-5.7c.7-1.8-.7-2.6-2.8-1.4m28-36.4c-2 1.3-5.7 5.2-5.8 9.6-.1 2.5-.6 2.5 1 4 1.3 1.8 2.4 1.7 4.8.4a5 5 0 0 0 2.3-3.4c.6-2.8-3 1.4-3.4-1.8-.8-3 1.5-4.2 3.7-7 0-2 0-3.3-2.7-1.8zm22.4 4a60 60 0 0 0-1.6 11.1c-.6 2.8 3 4 4.5.4 2.4-6.5 2.4-9.3 2.6-12-.7-4.3-3.6-4.2-5.5.5m142 72.3c.4-.5 20-14.4 20-14.4 2-.7 1.5 7.2.6 7.1a78 78 0 0 1-20.7 14.3c-1 .7-1.9-5.3 0-7zm17.7-.2c3.5 1.7 4.9 11.8 4.5 14.5 0 5.4-3.3 9.6-4.7 9-1.4-.7.2-6.7-.5-8.8-.8-3-3.7-8.5-3.2-10.1-1-3.4 1.8-5.2 4-4.6zm-116 43.4a26 26 0 0 1 5.6-4.9c2-1 3.8.8 3.7.7.3 2-1.2 3.7-.7 6.3.4 1 .7 2.2 2.6 1.8 3.1-2.5 6-2.7 9-2.8 2.5.1 2.6 4.2 1 4.2-5.7 1.2-8.2 2.8-12.3 4.3-2 1.2-3.6-.3-3.6-.4s-1.1-1.1-.4-3.7q.3-3.2-2.4-3c-1.2.8-2.4 1.2-3-.3q-.6-1.4.5-2.2m136.6 5.4c.8 1 1.4 2-.1 3.8l-3.7 3.2c-.6 1-1 2.8 1 3.3 3.6 1 12-4.5 12-4.6 1.4-1 1-3 .8-3-.8-.9-2.6-.3-3.8-.5-.6 0-2.5-.2-1.6-2a11 11 0 0 0 1.6-2.9q.9-1.7-2-2.7c-2.1-.4-3-.2-5.3 0q-1.6.2-1.9 2.3c.1 2.3 1.5 2.2 3 3z'
          />
          <path
            fill='#165d31'
            d='M268.1 189.7c-.5 1-2.3 1-4 0s-2.7-2.6-2.1-3.5 2.3-.9 4 0 2.6 2.6 2.1 3.5m-89-53.6c-1 .3-2.4-.6-3-2s-.3-2.6.7-2.9 2.3.7 3 2 .3 2.7-.8 3zM355.2 375c9.4.4 18.2 0 27.5.5 1.7 1.5.5 5-.6 4.8l-7.8-.3c-.1-3-7.7-2.5-7.5.1-4.1.5-7.8-.1-12-.3-1.2-1.5-1-4.2.4-4.8'
          />
        </g>
      </svg>
    ),
  },
  fa: {
    key: 'fa',
    name: 'فارسی',
    direction: 'right-to-left',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-ir' viewBox='0 0 640 480'>
        <defs>
          <clipPath id='ir-a'>
            <path fillOpacity='.7' d='M-85.3 0h682.7v512H-85.3z' />
          </clipPath>
        </defs>
        <g fillRule='evenodd' clipPath='url(#ir-a)' transform='translate(80)scale(.9375)'>
          <path fill='#fff' d='M-192 0h896v512h-896z' />
          <path fill='#da0000' d='M-192 343.8h896V512h-896z' />
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M-21.6 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z' />
            <path d='M52.4 367.7v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z' />
            <path d='M49.6 351H53v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M17.8 359.9H21V371h-3.3z' />
            <path d='M17.8 359.9H21V371h-3.3z' />
            <path d='M17.8 359.9H21V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371H7.3zm-14.3 0h3.4V371H-7z' />
            <path d='M9.6 367.7v3.4H-5.5v-3.4zm1-8.7v3.4H1V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M-102.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3H-95zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z' />
            <path d='M-28.2 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z' />
            <path d='M-31 351h3.4v20H-31zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M-62.8 359.9h3.3V371h-3.3z' />
            <path d='M-62.8 359.9h3.3V371h-3.3z' />
            <path d='M-62.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z' />
            <path d='M-71 367.7v3.4h-15v-3.4zm1-8.7v3.4h-9.6V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M58.3 351h49v3.3h-49zm7.3 16.8H69v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z' />
            <path d='M132.3 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M129.5 351h3.4v20h-3.4zm-8.4 0h3.4v20H121zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M97.7 359.9h3.4V371h-3.4z' />
            <path d='M97.7 359.9h3.4V371h-3.4z' />
            <path d='M97.7 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z' />
            <path d='M89.6 367.7v3.4H74.4v-3.4zm1-8.7v3.4H81V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M622.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H630zm41.9 0v3.3H662v-3.4zm5.3-16.8h3.3v20h-3.4z' />
            <path d='M696.7 367.7v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z' />
            <path d='M694 351h3.3v20h-3.4zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M662 359.9h3.5V371H662z' />
            <path d='M662 359.9h3.5V371H662z' />
            <path d='M662 359.9h3.5V371H662zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z' />
            <path d='M654 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M138.7 351h49.1v3.3h-49zm7.4 16.8h3.3v3.3h-3.3zm41.8 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z' />
            <path d='M212.8 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z' />
            <path d='M210 351h3.4v20H210zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z' />
            <path d='M178.1 359.9h3.4V371h-3.4z' />
            <path d='M178.1 359.9h3.4V371h-3.4z' />
            <path d='M178.1 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.2 0h3.3V371h-3.3z' />
            <path d='M170 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M219.5 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zM274 351h3.3v20H274z' />
            <path d='M293.5 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M290.7 351h3.4v20h-3.4zm-8.4 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M258.9 359.9h3.4V371h-3.4z' />
            <path d='M258.9 359.9h3.4V371h-3.4z' />
            <path d='M258.9 359.9h3.4V371h-3.4zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H234z' />
            <path d='M250.8 367.7v3.4h-15.2v-3.4zm1-8.7v3.4H242V359z' />
          </g>
          <path fill='#239f40' d='M-192 0h896v168.2h-896z' />
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M300.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H308zm41.9 0v3.3H340v-3.4zm5.3-16.8h3.3v20h-3.3z' />
            <path d='M374.7 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z' />
            <path d='M372 351h3.3v20H372zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M340 359.9h3.5V371H340z' />
            <path d='M340 359.9h3.5V371H340z' />
            <path d='M340 359.9h3.5V371H340zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z' />
            <path d='M332 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M381.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z' />
            <path d='M455.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M452.7 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z' />
            <path d='M420.8 359.9h3.4V371h-3.4z' />
            <path d='M420.8 359.9h3.4V371h-3.4z' />
            <path d='M420.8 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.3z' />
            <path d='M412.7 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H404V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M462.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z' />
            <path d='M536.2 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z' />
            <path d='M533.4 351h3.4v20h-3.4zm-8.4 0h3.3v20H525zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M501.6 359.9h3.3V371h-3.3z' />
            <path d='M501.6 359.9h3.3V371h-3.3z' />
            <path d='M501.6 359.9h3.3V371h-3.3zm-39.4 0h3.4V371h-3.4zm28.9 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z' />
            <path d='M493.4 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M543.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z' />
            <path d='M617.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z' />
            <path d='M614.6 351h3.4v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z' />
            <path d='M582.8 359.9h3.3V371h-3.3z' />
            <path d='M582.8 359.9h3.3V371h-3.3z' />
            <path d='M582.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H558z' />
            <path d='M574.6 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H566V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M-183.8 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z' />
            <path d='M-109.8 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M-112.5 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z' />
            <path d='M-144.4 359.9h3.4V371h-3.4z' />
            <path d='M-144.4 359.9h3.4V371h-3.4z' />
            <path d='M-144.4 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z' />
            <path d='M-152.5 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M-21.6 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z' />
            <path d='M52.4 160.2v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z' />
            <path d='M49.6 143.4H53v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M17.8 152.3H21v11.3h-3.3z' />
            <path d='M17.8 152.3H21v11.3h-3.3z' />
            <path d='M17.8 152.3H21v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3H7.3zm-14.3 0h3.4v11.3H-7z' />
            <path d='M9.6 160.2v3.4H-5.5v-3.4zm1-8.7v3.3H1v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M-102.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2H-95zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z' />
            <path d='M-28.2 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z' />
            <path d='M-31 143.4h3.4v20.2H-31zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M-62.8 152.3h3.3v11.3h-3.3z' />
            <path d='M-62.8 152.3h3.3v11.3h-3.3z' />
            <path d='M-62.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z' />
            <path d='M-71 160.2v3.4h-15v-3.4zm1-8.7v3.3h-9.6v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M58.3 143.4h49v3.4h-49zm7.3 17H69v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z' />
            <path d='M132.3 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M129.5 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2H121zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M97.7 152.3h3.4v11.3h-3.4z' />
            <path d='M97.7 152.3h3.4v11.3h-3.4z' />
            <path d='M97.7 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z' />
            <path d='M89.6 160.2v3.4H74.4v-3.4zm1-8.7v3.3H81v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M622.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H630zm41.9-.2v3.4H662v-3.4zm5.3-16.8h3.3v20.2h-3.4z' />
            <path d='M696.7 160.2v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z' />
            <path d='M694 143.4h3.3v20.2h-3.4zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M662 152.3h3.5v11.3H662z' />
            <path d='M662 152.3h3.5v11.3H662z' />
            <path d='M662 152.3h3.5v11.3H662zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z' />
            <path d='M654 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M138.7 143.4h49.1v3.4h-49zm7.4 17h3.3v3.2h-3.3zm41.8-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z' />
            <path d='M212.8 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z' />
            <path d='M210 143.4h3.4v20.2H210zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z' />
            <path d='M178.1 152.3h3.4v11.3h-3.4z' />
            <path d='M178.1 152.3h3.4v11.3h-3.4z' />
            <path d='M178.1 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.2 0h3.3v11.3h-3.3z' />
            <path d='M170 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M219.5 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.3v20.2H274z' />
            <path d='M293.5 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M290.7 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M258.9 152.3h3.4v11.3h-3.4z' />
            <path d='M258.9 152.3h3.4v11.3h-3.4z' />
            <path d='M258.9 152.3h3.4v11.3h-3.4zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H234z' />
            <path d='M250.8 160.2v3.4h-15.2v-3.4zm1-8.7v3.3H242v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M300.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H308zm41.9-.2v3.4H340v-3.4zm5.3-16.8h3.3v20.2h-3.3z' />
            <path d='M374.7 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z' />
            <path d='M372 143.4h3.3v20.2H372zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M340 152.3h3.5v11.3H340z' />
            <path d='M340 152.3h3.5v11.3H340z' />
            <path d='M340 152.3h3.5v11.3H340zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z' />
            <path d='M332 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M381.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z' />
            <path d='M455.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M452.7 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z' />
            <path d='M420.8 152.3h3.4v11.3h-3.4z' />
            <path d='M420.8 152.3h3.4v11.3h-3.4z' />
            <path d='M420.8 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.3z' />
            <path d='M412.7 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H404v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M462.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z' />
            <path d='M536.2 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z' />
            <path d='M533.4 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2H525zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M501.6 152.3h3.3v11.3h-3.3z' />
            <path d='M501.6 152.3h3.3v11.3h-3.3z' />
            <path d='M501.6 152.3h3.3v11.3h-3.3zm-39.4 0h3.4v11.3h-3.4zm28.9 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z' />
            <path d='M493.4 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M543.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z' />
            <path d='M617.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z' />
            <path d='M614.6 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z' />
            <path d='M582.8 152.3h3.3v11.3h-3.3z' />
            <path d='M582.8 152.3h3.3v11.3h-3.3z' />
            <path d='M582.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H558z' />
            <path d='M574.6 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H566v-3.3z' />
          </g>
          <g fill='#fff' strokeWidth='1pt'>
            <path d='M-183.8 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z' />
            <path d='M-109.8 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z' />
            <path d='M-112.5 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z' />
            <path d='M-144.4 152.3h3.4v11.3h-3.4z' />
            <path d='M-144.4 152.3h3.4v11.3h-3.4z' />
            <path d='M-144.4 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z' />
            <path d='M-152.5 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z' />
          </g>
          <path
            fill='#d90000'
            d='M-68.8 339.5h6V350h-6zm160.5 0h6V350h-6zm-283.7 0h6V350h-6zm81.5 0h6V350h-6zm80.9 0h6V350h-6zm40 0h6V350h-6zm40.9 0h6V350h-6zm80.4 0h6V350h-6zm203 0h6.1V350h-6zm-162.1 0h6V350h-6zm40 0h6V350h-6zm40.5 0h6V350h-6zm40.4 0h6V350h-6zm323.2 0h6V350h-6zm-242.7 0h6V350h-6zm40.8 0h6V350h-6zm41.3 0h6V350h-6zm38.8 0h6V350h-6zm41.3 0h6V350h-6zm40.4 0h6V350h-6zm119.7 0h6V350h-6zm-38.8 0h6V350h-6zm-808.9 0h6V350h-6z'
          />
          <path
            fill='#239e3f'
            d='M-68.8 162.6h6v10.5h-6zm160.5 0h6v10.5h-6zm-283.7 0h6v10.5h-6zm81.5 0h6v10.5h-6zm80.9 0h6v10.5h-6zm40 0h6v10.5h-6zm40.9 0h6v10.5h-6zm80.4 0h6v10.5h-6zm203 0h6.1v10.5h-6zm-162.1 0h6v10.5h-6zm40 0h6v10.5h-6zm40.5 0h6v10.5h-6zm40.4 0h6v10.5h-6zm323.2 0h6v10.5h-6zm-242.7 0h6v10.5h-6zm40.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm38.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm40.4 0h6v10.5h-6zm119.7 0h6v10.5h-6zm-38.8 0h6v10.5h-6zm-808.9 0h6v10.5h-6z'
          />
          <g fill='#da0000'>
            <path d='M279.8 197.5c8.4 10.4 34.5 67.6-15.7 105.2-23.7 17.8-9 18.6-8.3 21.6 38-20.1 50.3-47.5 50-72-.2-24.4-13.2-46-26-54.8' />
            <path d='M284.8 194.8a73.3 73.3 0 0 1 15.7 112.4c27.2-6 62-86.4-15.7-112.4m-57.6 0a73.3 73.3 0 0 0-15.6 112.4c-27.3-6-62-86.4 15.6-112.4' />
            <path d='M232.2 197.5c-8.4 10.4-34.5 67.6 15.7 105.2 23.6 17.8 9 18.6 8.3 21.6-38-20.1-50.3-47.5-50-72 .2-24.4 13.2-46 26-54.8' />
            <path d='M304.2 319.1c-14.9.2-33.6-2-47.5-9.3 2.3 4.5 4.2 7.3 6.5 11.7 13.2 1.3 31.5 2.8 41-2.4m-95 0c14.9.2 33.6-2 47.5-9.3-2.3 4.5-4.2 7.3-6.5 11.7-13.2 1.3-31.5 2.8-41-2.4m27.3-138.7c3 8 10.9 9.2 19.3 4.5 6.2 3.6 15.7 3.9 19-4.1 2.5 19.8-18.3 15-19 11.2-7.8 7.5-22.2 3.2-19.3-11.6' />
            <path d='m256.4 331.6 7.8-9 1.1-120.1-9.3-8.2-9.3 7.8 1.9 121z' />
          </g>
        </g>
      </svg>
    ),
  },
  tr: {
    key: 'tr',
    name: 'Türkçe',
    direction: 'left-to-right',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-tr' viewBox='0 0 640 480'>
        <g fillRule='evenodd'>
          <path fill='#e30a17' d='M0 0h640v480H0z' />
          <path
            fill='#fff'
            d='M407 247.5c0 66.2-54.6 119.9-122 119.9s-122-53.7-122-120 54.6-119.8 122-119.8 122 53.7 122 119.9'
          />
          <path
            fill='#e30a17'
            d='M413 247.5c0 53-43.6 95.9-97.5 95.9s-97.6-43-97.6-96 43.7-95.8 97.6-95.8 97.6 42.9 97.6 95.9z'
          />
          <path
            fill='#fff'
            d='m430.7 191.5-1 44.3-41.3 11.2 40.8 14.5-1 40.7 26.5-31.8 40.2 14-23.2-34.1 28.3-33.9-43.5 12-25.8-37z'
          />
        </g>
      </svg>
    ),
  },
  ua: {
    key: 'ua',
    name: 'Українська',
    direction: 'left-to-right',
    flag: (
      <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-ua' viewBox='0 0 640 480'>
        <g fillRule='evenodd' strokeWidth='1pt'>
          <path fill='gold' d='M0 0h640v480H0z' />
          <path fill='#0057b8' d='M0 0h640v240H0z' />
        </g>
      </svg>
    ),
  },
};

// TODO: window.isInternationalizationOn here and in other places are for a/b purpose. Once a/b is done need to remove it from every place
// TODO: REMOVE BEFORE RELEASE. This variable should be assigned within optimizely test only
// window.isInternationalizationOn = true;

export default class I18nManager {
  constructor() {
    this.isInternationalizationOn = false;
    this.map = MAP;
    this.languages = [];
    this.#initI18n(translations);
  }

  setIsInternationalizationOn(v) {
    this.isInternationalizationOn = v;
  }

  #i18nInstance = i18n;

  #getResources(input = {}) {
    const result = {};
    for (const key in input) {
      if (input.hasOwnProperty(key)) {
        for (const lang in input[key]) {
          if (input[key].hasOwnProperty(lang)) {
            if (!result[lang]) {
              result[lang] = { translation: {} };
            }
            result[lang].translation[key] = input[key][lang];
          }
        }
      }
    }
    return result;
  }

  #getInitLang(translations) {
    const resourcesLanguages = Object.keys(this.#getResources(translations));
    const searchParams = new URLSearchParams(location.search);
    const paramsLanguage = searchParams.get('utm_lang') || '';
    const browserLanguage = new Intl.Locale(navigator.language).language;
    // TODO: window.isInternationalizationOn here and in other places are for a/b purpose. Once a/b is done need to remove it from every place
    if (window.isInternationalizationOn || this.isInternationalizationOn) {
      const isBrowserLangInResources = resourcesLanguages.includes(browserLanguage);
      if (paramsLanguage) {
        return get(MAP[paramsLanguage], 'key', DEFAULT_LANG);
      }
      if (isBrowserLangInResources && browserLanguage === 'en') {
        return DEFAULT_LANG;
      }
      return isBrowserLangInResources ? get(MAP[browserLanguage], 'key', DEFAULT_LANG) : '' || DEFAULT_LANG;
    } else {
      return DEFAULT_LANG;
    }
  }

  #initI18n(translations) {
    const lang = this.#getInitLang(translations);
    const resources = this.#getResources(translations);

    this.languages = Object.keys(resources).map((country) => MAP[country]);

    this.#i18nInstance.use(initReactI18next).init({
      resources,
      lng: lang,
      interpolation: {
        escapeValue: false,
      },
    });
    this.#i18nInstance.language = lang;
  }

  getLanguage() {
    return this.languages.find((l) => l.key === this.#i18nInstance.language);
  }

  getDirection(langKey) {
    return this.languages.find((l) => l.key === langKey).direction;
  }
}
